module.exports = __webpack_public_path__ + "img/grow_sell.6c999f7d.svg";